import { notification } from 'antd';
import http from 'utils/http';

export const getAllProducts = async (params) => {
  try {
    const response = await http.get(`/public/v1/product`, { params });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const getProductApiLogs = async (id, storeId, start_date, end_date) => {
  try {
    const response = await http.get(`/public/v1/product/cloudwatch/${id}/logs?store_id=${storeId}&start_date=${start_date}&end_date=${end_date}`);
    return response;
  } catch (err) {}
};

export const getSingleProduct = async (storeId, id) => {
  try {
    const response = await http.get(`/public/v1/product/${id}?store_id=${storeId}`);
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const addProduct = async (storeId, payload) => {
  try {
    const response = await http.post(`/public/v1/product?store_id=${storeId}`, payload);
    notification?.success({ message: 'New Product Added', description: 'New Product has been added successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const deleteProduct = async (storeId, id) => {
  try {
    const response = await http.delete(`/public/v1/product/${id}?store_id=${storeId}`);
    notification?.success({ message: 'Product Deleted', description: 'Product has been deleted successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const updateProduct = async (storeId, id, payload) => {
  try {
    const response = await http.patch(`/public/v1/product/${id}?store_id=${storeId}`, payload);
    notification?.success({ message: 'Product Updated', description: 'Product information has been updated successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const getAllMeters = async (params) => {
  try {
    const response = await http.get(`/public/v1/meter`, { params });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const getSingleMeter = async (storeId, id) => {
  try {
    const response = await http.get(`/public/v1/meter/${id}`, { params: { store_id: storeId } });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const addMeter = async (storeId, payload) => {
  try {
    const response = await http.post(`/public/v1/meter?store_id=${storeId}`, payload);
    notification?.success({ message: 'New Meter Added', description: 'New Meter has been added successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const updateMeter = async (id, payload) => {
  try {
    const response = await http.patch(`/public/v1/meter/${id}`, payload);
    notification?.success({ message: 'Meter Updated', description: 'Meter information has been updated successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const deleteMeter = async (storeId, id) => {
  try {
    const response = await http.delete(`/public/v1/meter/${id}`, { params: { store_id: storeId } });
    notification?.success({ message: 'Meter Deleted', description: 'Meter has been deleted successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const getAllPricingModels = async (params) => {
  try {
    const response = await http.get(`/public/v1/pricing/model/list`, { params });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const getSinglePricingModel = async (storeId, id) => {
  try {
    const response = await http.get(`/public/v1/pricing/model/${id}`, { params: { store_id: storeId } });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const addPricingModel = async (storeId, payload) => {
  try {
    const response = await http.post(`/public/v1/pricing/model?store_id=${storeId}`, payload);
    notification?.success({ message: 'New Pricing Model Added', description: 'New Pricing Model has been added successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const updatePricingModel = async (id, payload) => {
  try {
    const response = await http.patch(`/public/v1/pricing/model/${id}`, payload);
    notification?.success({ message: 'Pricing Model Updated', description: 'Pricing Model information has been updated successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const deletePricingModel = async (storeId, id, payload) => {
  try {
    const response = await http.post(`/public/v1/pricing/model/${id}?store_id=${storeId}`, payload);
    notification?.success({ message: 'Pricing Model Deleted', description: 'Pricing Model has been deleted successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const getAllPlans = async (params) => {
  try {
    const response = await http.get(`/public/v1/plan`, { params });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const getPlanApiLogs = async (id, storeId, start_date, end_date) => {
  try {
    const response = await http.get(`/public/v1/plan/cloudwatch/${id}/logs?store_id=${storeId}&start_date=${start_date}&end_date=${end_date}`);
    return response;
  } catch (err) {}
};

export const getSinglePlan = async (storeId, id) => {
  try {
    const response = await http.get(`/public/v1/plan/${id}?store_id=${storeId}`);
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const addPlan = async (storeId, payload) => {
  try {
    const response = await http.post(`/public/v1/plan?store_id=${storeId}`, payload);
    notification?.success({ message: 'New Plan Added', description: 'New Plan has been added successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const updatePlan = async (storeId, id, payload) => {
  try {
    const response = await http.patch(`/public/v1/plan/${id}?store_id=${storeId}`, payload);
    notification?.success({ message: 'Plan Updated', description: 'Plan information has been updated successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const deletePlan = async (storeId, id) => {
  try {
    const response = await http.delete(`/public/v1/plan/${id}?store_id=${storeId}`);
    notification?.success({ message: 'Plan Deleted', description: 'Plan has been deleted successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const removeProductFromPlan = async (storeId, plan_id, product_id) => {
  try {
    const response = await http.delete(`/public/v1/plan/${plan_id}/product?store_id=${storeId}&product_id=${product_id}`);
    notification?.success({ message: response?.data?.message, placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const getTokenList = async (params) => {
  try {
    const response = await http.get(`/public/v1/token`, { params });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const getAllSubscription = async (params) => {
  try {
    const response = await http.get(`/public/v1/subscription`, { params });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const getSubscriptionApiLogs = async (id, storeId, start_date, end_date) => {
  try {
    const response = await http.get(`/public/v1/subscription/cloudwatch/${id}/logs?store_id=${storeId}&start_date=${start_date}&end_date=${end_date}`);
    return response;
  } catch (err) {}
};
export const getSingleSubscription = async (storeId, id) => {
  try {
    const response = await http.get(`/public/v1/subscription/${id}?store_id=${storeId}`);
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const addSubscription = async (storeId, payload) => {
  try {
    const response = await http.post(`/public/v1/subscription?store_id=${storeId}`, payload);
    notification?.success({ message: 'New Subscription Added', description: 'New Subscription has been added successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const updateSubscription = async (storeId, id, payload) => {
  try {
    const response = await http.patch(`/public/v1/subscription/${id}?store_id=${storeId}`, payload);
    notification?.success({ message: 'Subscription Updated', description: 'Subscription information has been updated successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const cancelSubscription = async (storeId, id, payload) => {
  try {
    const response = await http.post(`/public/v1/subscription/${id}/cancel?store_id=${storeId}`, payload);
    notification?.success({ message: 'Subscription Canceled', description: 'Subscription has been Canceled successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const resumeSubscription = async (storeId, id, payload) => {
  try {
    const response = await http.post(`/public/v1/subscription/${id}/resume?store_id=${storeId}`, payload);
    notification?.success({ message: 'Subscription Resumed', description: 'Subscription has been Resumed successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message?.message?.message || err?.response?.data?.message?.message || err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const pauseSubscription = async (storeId, id, payload) => {
  try {
    const response = await http.post(`/public/v1/subscription/${id}/pause?store_id=${storeId}`, payload);
    notification?.success({ message: 'Subscription Paused', description: 'Subscription has been Paused successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const payInvoice = async (storeId, id, payload) => {
  try {
    const response = await http.post(`/public/v1/invoice/${id}/pay?store_id=${storeId}`, payload);
    notification?.success({ message: response?.data?.message, placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const RejectInvoice = async (storeId, id) => {
  try {
    const response = await http.post(`/public/v1/invoice/reject/${id}?store_id=${storeId}`);
    notification?.success({ message: response?.data?.message, placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const paymentRefund = async (storeId, id) => {
  try {
    const response = await http.post(`/public/v1/invoice/${id}/refund?store_id=${storeId}`);
    notification?.success({ message: response?.data?.message, placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const failInvoicesTag = async (storeId, payload) => {
  try {
    const response = await http.post(`/public/v1/invoice/unpaid?store_id=${storeId}`, payload);
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const skipSubscription = async (storeId, id, payload) => {
  try {
    const response = await http.post(`/public/v1/subscription/${id}/skip?store_id=${storeId}`, payload);
    notification?.success({ message: 'Subscription Skipped', description: 'Subscription has been Skipped successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const unskipSubscription = async (storeId, id, payload) => {
  try {
    const response = await http.post(`/public/v1/subscription/${id}/unskip?store_id=${storeId}`, payload);
    notification?.success({ message: 'Subscription Unskipped', description: 'Subscription has been Unskipped successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const getProductPlans = async (id, storeId) => {
  try {
    const response = await http.get(`/public/v1/product/${id}/plans?store_id=${storeId}`);
    return response;
  } catch (err) {}
};

export const proratedInvoicesStatus = async (storeId, payload) => {
  try {
    const response = await http.post(`/public/v1/invoice/status?store_id=${storeId}`, payload);
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};
export const getAllInvoices = async (params) => {
  try {
    const response = await http.get(`/public/v1/invoice`, { params });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const getSingleInvoice = async (storeId, id) => {
  try {
    const response = await http.get(`/public/v1/invoice/${id}?store_id=${storeId}`);
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const getInvoiceAttachmentSignedUrl = async (storeId, fileName) => {
  try {
    const response = await http.get(`/public/v1/invoice/signed-url?store_id=${storeId}&fileName=${encodeURIComponent(fileName)}`);
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'Failed to get upload URL', placement: 'bottomRight' });
  }
};

export const getInvoiceAttachmentDownloadSignedUrl = async (storeId, invoiceId) => {
  try {
    const response = await http.get(`/public/v1/invoice/${invoiceId}/attachment/url?store_id=${storeId}`);
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'Failed to get download URL', placement: 'bottomRight' });
  }
};

export const markPaidSingleInvoice = async (storeId, id, payload) => {
  try {
    const response = await http.post(`/public/v1/invoice/${id}/mark/paid?store_id=${storeId}`, payload);
    notification?.success({ message: 'Invoice Paid', description: 'Invoice has been paid successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const sendInvoicePaymentLink = async (storeId, payload) => {
  try {
    const response = await http.post(`/public/v1/invoice/payment/link?store_id=${storeId}`, payload);
    notification?.success({ message: 'Invoice Payment Link', description: 'Invoice payment link has been sent successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const emailInvoicePdf = async (storeId, payload) => {
  try {
    const response = await http.post(`/public/v1/invoice/email/pdf?store_id=${storeId}`, payload);
    notification?.success({ message: 'Invoice PDF', description: 'Invoice PDF email has been sent successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const getFutureInvoices = async (params) => {
  try {
    const response = await http.get(`/public/v1/invoice/scheduled/future`, { params });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const rescheduledInvoice = async (storeId, id, payload) => {
  try {
    const response = await http.put(`/public/v1/invoice/${id}/update?store_id=${storeId}`, payload);
    notification?.success({ message: 'Invoice Rescheduled', description: 'Invoice has been rescheduled successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};
export const getAllCustomer = async (params, storeId) => {
  try {
    const response = await http.get(`/public/v1/customer/list`, { params });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const createCustomer = async (storeId, payload) => {
  try {
    const response = await http.post(`/public/v1/customer?store_id=${storeId}`, payload);
    notification?.success({ message: 'New Customer Added', description: 'New Customer has been added successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const updateCustomer = async (storeId, id, payload) => {
  try {
    const response = await http.patch(`/public/v1/customer/${id}?store_id=${storeId}`, payload);
    notification?.success({ message: 'Customer updated', description: 'Customer information has been updated successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const getSingleCustomer = async (storeId, id) => {
  try {
    const response = await http.get(`/public/v1/customer/${id}?store_id=${storeId}`);
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const deleteSingleCustomer = async (storeId, id) => {
  try {
    const response = await http.delete(`/public/v1/customer/${id}?store_id=${storeId}`);
    notification?.success({ message: 'Customer Deleted', description: 'Customer has been deleted successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const getAllBillingInvoices = async (params) => {
  try {
    const response = await http.get(`/public/v1/merchant/billing`, { params });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const getBillingInvoiceDetail = async (storeId, id) => {
  try {
    const response = await http.get(`/public/v1/merchant/billing/${id}?store_id=${storeId}`);
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const billingEmailInvoicePdf = async (storeId, payload) => {
  try {
    const response = await http.post(`/public/v1/merchant/billing/email/pdf?store_id=${storeId}`, payload);
    notification?.success({ message: 'Invoice PDF', description: 'Invoice PDF email has been sent successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification?.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};
